'use client'

import { type ComponentProps, createContext, type FC, useContext } from 'react'
import { type AppConfig } from 'ecosystem'

export const createAppConfigContext = <T extends AppConfig>(appConfig: T) => {
  const AppConfigContext = createContext<AppConfig | undefined>(undefined)

  type ProviderProps = ComponentProps<typeof AppConfigContext.Provider>

  const Provider: FC<ProviderProps> = ({ value, children }) => (
    <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>
  )

  const useAppConfigContext = (): T => {
    const contextValue = useContext(AppConfigContext)

    return (contextValue as T | undefined) ?? appConfig
  }

  return [Provider, useAppConfigContext, AppConfigContext] as const
}
